import { SpotlightStatus } from './enums';
import { EntityTypes } from './enums/entityTypes';

export interface SupplierSpotlight {
  spotlightId: string;
  supplierId: string;
  supplierName: string;
  supplierDescription: string;
  spotlightStatus: SpotlightStatus;
  entityType: EntityTypes.supplierSpotlight;
  created: number;
  lastUpdated: number;
  expires: number;
}
